import { render, staticRenderFns } from "./resurvey.vue?vue&type=template&id=c9bc83d6&scoped=true&"
import script from "./resurvey.vue?vue&type=script&lang=tsx&"
export * from "./resurvey.vue?vue&type=script&lang=tsx&"
import style0 from "./resurvey.vue?vue&type=style&index=0&id=c9bc83d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9bc83d6",
  null
  
)

export default component.exports